// extracted by mini-css-extract-plugin
module.exports = {"prosStyle":"ProsAndCons_prosStyle__Z6ZRe","consStyle":"ProsAndCons_consStyle__HfaJo"};